<template>
	<div
		:class="['c-sheet-view hook-container', { dragging: dragging === true }]"
		@click="onClick"
	>
		<Renderer
			ref="renderer"
			:currentBlock="currentBlock"
			v-if="currentBlock"
		></Renderer>
		<DragSelect
			@dragStart="dragging = true"
			@dragEnd="dragging = false"
		></DragSelect>
		<!-- <Debug></Debug> -->
		<!-- <button class="btn" @click="$bvModal.show('modal-settings')">
			Show settings
		</button> -->
		<!-- <Footer></Footer> -->
	</div>
</template>

<script>
import Renderer from '@/components/dashboard/renderer';
import Footer from '@/components/dashboard/footer';
import DragSelect from '@/components/dashboard/drag-select';
import Debug from '@/components/ui/debug';
import $ from 'jquery';

export default {
	components: {
		Renderer,
		Footer,
		DragSelect,
		Debug,
	},

	data: function () {
		return {
			dragging: false,
			selection: [],
			dragSelect: null,
		};
	},

	props: {
		blockId: String,
	},

	watch: {
		dataTransfer: function () {
			this.onDataTransfer();
		},
	},

	computed: {
		dataTransfer: function () {
			return this.$store.state.dataTransfer;
		},
		currentBlock: function () {
			let block = null;
			if (this.blockId) {
				block = this.$store.getters['block/block'](this.blockId);
				return block;
			} else {
				block = this.$store.getters['block/rootBlock'];
				return block;
			}
		},
	},

	methods: {
		onDataTransfer: function () {
			if (!this.dataTransfer) {
				return;
			}
			if (this.dataTransfer.type === 'data') {
				this.$refs.renderer.addBlock(this.dataTransfer);
				//this.editor.commands.insertContent(this.dataTransfer.payload.html);
			}
		},
		getBlockOnClick: function (e) {
			let mouse = {
				x: 0,
				y: e.clientY,
			};
			mouse.x = window.document.body.offsetWidth / 2;

			let el = document.elementFromPoint(mouse.x, mouse.y);

			let check = $(el).closest('.c-block');
			let id = null;
			if (check.length > 0) {
				id = check.data('id') || null;
			}
			this.$refs.renderer.focusOnLastBlock(id);
		},
		onClick: function (e) {
			if (e.target.classList.contains('c-sheet-view')) {
				this.getBlockOnClick(e);
				//this.$refs.renderer.focusOnLastBlock();
			}
		},
	},
};
</script>

<style lang="scss">
.c-sheet-view {
	width: 100%;
	min-height: calc(100% - var(--spacer-lg));
	position: relative;
	overflow-x: hidden;

	@include scrollBars();

	&.dragging {
		user-select: none;
		pointer-events: none;
	}
}
.ds-selector {
	border: none !important;
	background-color: rgba(var(--p-r), var(--p-g), var(--p-b), 0.5) !important;
}
</style>